<template>
    <div>
        <div class="mb-5">
            <GetFile :title="$t('buttons.download_sample')"
                     :loader="sampleLoader"
                     @get-file="getSample"></GetFile>
        </div>
        <div class="text-center">
            <FileInput name="file"
                       ref="file"
                       :button-title="title"
                       class-name="justify-center"
                       :accept="acceptedFiles"
                       input-id="employees"
                       v-model="file">
                <template slot="icon"
                          v-if="loader">
                    <CircularLoader class="mr-3"></CircularLoader>
                </template>
            </FileInput>
        </div>
        <InformationDialog @close="informationVisibility = false"
                           @visibility="informationVisibility = $event"
                           :dialog="informationVisibility"
                           :text="text"></InformationDialog>
    </div>
</template>

<script>
import GetFile from '@/components/widgets/buttons/GetFile';
import FileInput from '@/components/widgets/forms/FileInput';
import CircularLoader from '@/components/widgets/CircularLoader';
import InformationDialog from '@/components/widgets/dialogs/InformationDialog';

export default {
    name: 'ImportEmployeesForm',
    components: { GetFile, FileInput, CircularLoader, InformationDialog },
    props: {
        positionType: {
            type: String,
            required: false
        }
    },
    data: () => ({
        sampleLoader: false,
        dialog: false,
        acceptedFiles: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        file: [],
        text: '',
        loader: false,
        informationVisibility: false
    }),
    computed: {
        i18 () {
            const i18 = this.$t('configurations.imports.import_employees_instructions.columns');
            return this.positionType === 'elements'
                ? i18['13'].concat('- item') && i18
                : i18;
        },
        title () {
            return this.positionType === 'elements' ? this.$t('configurations.imports.import_elements')
                : this.$t('configurations.imports.import_employees');
        }
    },
    watch: {
        file: {
            handler (val) {
                if (val && val.length > 0) {
                    this.importEmployees(val);
                }
            },
            deep: true
        }
    },
    methods: {
        positionTypeField (item) {
            if (this.positionType === 'elements') {
                return item;
            }
        },
        clearFile () {
            this.$refs.file.clearFiles();
        },
        getSample () {
            this.sampleLoader = true;

            return this.$store.dispatch('commonActions/downloadSampleXLSX', {
                kind: 'employees'
            })
                .finally(() => {
                    this.sampleLoader = false;
                });
        },
        importEmployees (val) {
            this.loader = true;
            this.$store.dispatch('employees/importEmployees', val[0].content.split(',')[1])
                .then((data) => {
                    const count = data.data.meta.message.split(':')[1];
                    if (parseInt(count) > 0) {
                        this.text = this.$t('messages.correct_import_employees') + '. ' + this.$t('labels.all_records') + ': ' + count;
                    } else {
                        this.text = this.$t('labels.all_records') + ': ' + count;
                    }
                    this.informationVisibility = true;
                    this.clearFile();
                    this.$emit('fetch');
                })
                .finally(() => {
                    this.loader = false;
                });
        }
    }
};
</script>

<style scoped>

</style>
